/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Users_Invite_SentInputs */

const cs_users_invite_sent = /** @type {(inputs: Users_Invite_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pozvánka odeslána: ${i?.count}`)
};

const en_users_invite_sent = /** @type {(inputs: Users_Invite_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitations sent: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Invitations sent: {count}" |
*
* @param {Users_Invite_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_sent = /** @type {((inputs: Users_Invite_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_sent(inputs)
	return cs_users_invite_sent(inputs)
});